module.exports = __webpack_public_path__ + "img/resort-06.a4b98bc1.jpg";